import {
  DefaultButton,
  SearchBarComponent,
  SearchMenu,
  Toggle,
  Modal,
  HeaderPage,
  Loading,
  FilterMulti,
  SelectedSpecialists,
  Filter2,
  Kanban2,
  NewModal,
  FinancialCard,
} from 'components/index'
import { Icon } from 'assets/index'
import { useContext, useEffect, useState, useCallback } from 'react'
import { UserContext, GeneralContext } from 'context'
import { PageScrollContent } from 'styles'
import { useStorage, useSocket, useFetch } from 'hooks'
import { IObject } from 'interfaces'
import { clearString, hasAccess } from 'helper/utils'
import { logoSmall } from 'assets/Icons'
import DeleteProposta from 'pages/Clientes/DeleteProposta'
import getTotalValueFromColumn from 'helper/getTotalValueFromColumn'
import getContractFromColumn from 'helper/getContractFromColumn'
import { generateKankanFilterDate } from 'helper/generateKankanFilterDate'
import { sortCardsByName } from 'helper/sortCardsByName'
import useFetch2 from 'hooks/useFetch2'
import Extrato from './Extract'
import SearchDates, {
  DateRange,
} from '../../components/SearchDates/SearchDates'
import Depositar from './Depositar'
import Transferir from './Transferir'
import DetalhesFinanceiro from './DetalhesFinanceiro'
import { Container, KanbanEnviromnent, Line } from './style'
import ResumoTransferir from './Transferir/ResumoTransferir'
import ResumoDepositar from './Depositar/ResumoDepositar'
import { CONNECTION } from '../../configs/configs.js'

const modalMovimentacaoEscolhida: any = [
  [
    <DetalhesFinanceiro key="detalhesFinanceiro" />,
    'Detalhes do cliente > Produtos > Detalhes do investimento',
    (): void => {
      console.log('avançar 1')
    },
    (): void => {
      console.log('voltar 1')
    },
  ],
]

const optGeneral = [
  ['Fluxo de pagamentos', 'pagamentos'],
  ['Saques', 'saques', true],
  ['Extrato', 'extrato', true],
]

export default function Financeiro() {
  // const modalDepositar: any = [
  //   [
  //     <Depositar key="deposit" />,
  //     'Movimentações > Rentabilidade > Depositar',
  //     (): void => {
  //       console.log('avançar 1')
  //     },
  //     (): void => {
  //       console.log('voltar 1')
  //     },
  //   ],
  // ]

  // const modalMovimentacaoEscolhida: any = [
  //   [
  //     <DetalhesFinanceiro key="detalhesFinanceiro" />,
  //     'Detalhes do cliente > Produtos > Detalhes do investimento',
  //     (): void => {
  //       console.log('avançar 1')
  //     },
  //     (): void => {
  //       console.log('voltar 1')
  //     },
  //   ],
  // ]
  // const optGeneral = [
  //   ['Fluxo de pagamentos', 'pagamentos'],
  //   ['Saques', 'saques', true],
  //   ['Extrato', 'extrato'],
  // ]
  const { showModal, setShowModal, setData, selectedId, setPage } =
    useContext(UserContext)
  const general: any = useContext(GeneralContext)
  const [kanbanDataOriginal, setKanbanDataOriginal] = useState<any>([])
  const [kanbanData, setKanbanData] = useState<any[]>([])
  const [loadingKanban, setLoadingKanban] = useState<boolean>(true)
  const [colaboradores] = useStorage('Colaboradores')
  const [especialists] = useStorage('Especialistas')
  const [extractData, setExtractData] = useState<Array<any>>([])

  const [pallete] = useStorage('pallete')
  const [reqLoading, setReqLoading] = useState<boolean>(false)
  const [toggle, setToggle] = useState('pagamentos')
  const [enterprisesOptions, setEnterprisesOptions] = useState<any[]>([
    { label: '', value: '' },
  ])
  const [contractOptions, setContractOptions] = useState<any[]>([])
  const [showDataPicker, setShowDataPicker] = useState(false)
  const [selectedEnterprise, setSelectedEnterprise] = useState<{
    label: string
    value: string
  } | null>(null)

  const modalTransferir: any = [
    [
      <Transferir
        key="transfer"
        enterprise={{
          name: selectedEnterprise?.label || '',
          id: selectedEnterprise?.value,
        }}
      />,
      'Financeiro >  Transferir',
    ],
    [<ResumoTransferir key="resumoTransferir" />, 'Financeiro >  Transferir'],
  ]

  const modalDepositar: any = [
    [
      <Depositar
        key="deposit"
        enterprise={{
          name: selectedEnterprise?.label || '',
          id: selectedEnterprise?.value,
        }}
      />,
      'Financeiro >  Depositar',
    ],
    [<ResumoDepositar />, 'Financeiro >  Depositar'],
  ]

  // RENDERIZACAO DE MODAL
  const [modalData, setModalData] = useState('')
  const [localModal, setLocalModal] = useState(false)
  const [transcModal, setTransacModal] = useState<any>(false)

  // FILTROS DE BUSCA PREENCHIDOS
  const [selectedContract, setSelectedContract] = useState<any>([])
  const [documentCliente, setDocumentoCliente] = useState('')
  const [especialistaFiltro, setEspecialistaFiltro] = useState<any>([])
  const [gestors] = useStorage('Gestores')
  const [gestSpecialist] = useStorage('GestSpec')
  const [selectedGestor, setSelectedGestor] = useState<any>(null)
  const filteredEspecialistOptionsInitial = [
    ...(gestSpecialist || []),
    ...(especialists || []),
  ]

  const [filteredEspecialistOptions, setFilteredEspecialistOptions] = useState(
    filteredEspecialistOptionsInitial
  )
  const [cardData, setCardData] = useState<any>(null)
  const [payToday, setPayToday] = useState(0)
  const [dateRange, setDateRange] = useState<DateRange>({
    startDate: null,
    endDate: null,
  })
  const [searchMenuIsExpanded, setSearchMenuIsExpanded] = useState(false) // abrir e fechar o menu de busca

  const api = useFetch('/')
  const apiT = useFetch2('/')

  const openDepositar = () => {
    setTransacModal(modalDepositar)
  }

  const openTransferir = () => {
    setPage(0)
    setTransacModal(modalTransferir)
  }

  const openDetails = async (cur: any) => {
    setModalData(modalMovimentacaoEscolhida)
    selectedId.current = cur
    setShowModal(true)
  }

  const fetchData = useCallback(async () => {
    try {
      const promises = [
        api.fetch('get', null, `/gestor/kanban/withdraw`),
        api.fetch('get', null, `/gestor/financial/client`),
      ]

      const [kanban, cards] = await Promise.all(promises)

      // Create a map for quick lookups
      const collaboratorMap = new Map(
        colaboradores.map((item: any) => [item.id, item])
      )

      kanban?.data?.data?.forEach((pipeline: any) => {
        pipeline.cardList.forEach((card: any) => {
          const specialist: any = collaboratorMap.get(card.specialistId)
          card.specialist = specialist
            ? {
                id: specialist.id,
                name: specialist.name,
                profilePicture: specialist.profilePic,
              }
            : general.gestor.default
          // Os cards usam somente a lista tags. taglist deixa de ser usada depois de mapeada
          card.tags = card.tagList
            ? card.tagList.map((item: IObject) => ({
                ...item,
                background: pallete[item.background || 'BLACK'],
                color: pallete[item.color || 'WHITE'],
              }))
            : [
                { value: card.status, color: '#FFFFFF', background: '#00CD52' },
                {
                  value: card?.amount,
                  color: '#FFFFFF',
                  background: '#1C1D22',
                },
              ]
        })
      })

      const sortedByNameKanban = sortCardsByName(kanban.data.data)

      const kanbanWithFilterDate = generateKankanFilterDate(sortedByNameKanban)

      kanban.data && setKanbanData(kanbanWithFilterDate)
      kanban.data && setKanbanDataOriginal(kanbanWithFilterDate)

      cards.data &&
        (() => {
          const c: any = cards.data.data
          setData({
            account: { label: 'Conta Atto', value: 'main_account' },
            history: c.history,
          })
        })()
    } catch (error) {
      console.error('Error:', error)
    }
  }, [])

  useEffect(() => {
    if (!kanbanDataOriginal) return

    const arr: any[] = []
    kanbanData.forEach((item: any) => {
      if (item.id === -1 || item.id === -2) {
        arr.push(...item.cardList)
      }
    })
  }, [kanbanDataOriginal])

  const fetchEnterpriseKanban = async (e: any) => {
    let promiseSelection: any[] = []
    e.value === 'main_account'
      ? (promiseSelection = [
          api.fetch('get', null, `/gestor/kanban/withdraw`),
          api.fetch('get', null, `/gestor/financial/client`),
        ])
      : (promiseSelection = [
          api.fetch('get', null, `/gestor/kanban/payments?id=${e.value}`),
          api.fetch('get', null, `/gestor/financial/enterprise?id=${e.value}`),
        ])
    const [kanban, cards] = await Promise.all(promiseSelection)

    kanban.data.data.forEach((pipeline: any) => {
      pipeline.cardList.forEach((card: any) => {
        const specialist = colaboradores.find(
          (item: any) => item.id === card.specialistId
        )
        card.specialist = specialist
          ? {
              id: specialist.id,
              name: specialist.name,
              profilePicture: specialist.profilePic,
            }
          : general.gestor.default

        // console.log(card.tagList)
        card.tags = card.tagList
          ? card.tagList.map((item: IObject) => ({
              ...item,
              background: pallete[item.background || 'BLACK'],
              color: pallete[item.color || 'WHITE'],
            }))
          : [
              { value: card.status, color: '#FFFFFF', background: '#00CD52' },
              { value: card.type, color: '#1C1D22', background: '#FFFFFF' },
            ]
      })
    })

    const sortedByNameKanban = sortCardsByName(kanban.data.data)

    const kanbanWithFilterDate = generateKankanFilterDate(sortedByNameKanban)

    setCardData(cards.data.data)

    kanban.data && setKanbanData(kanbanWithFilterDate)
    kanban.data && setKanbanDataOriginal(kanbanWithFilterDate)

    cards.data &&
      (() => {
        setData({
          account: e,
        })
      })()
  }

  useEffect(() => {
    const hasData =
      kanbanDataOriginal.length > 9 &&
      kanbanDataOriginal[7]?.cardList &&
      kanbanDataOriginal[8]?.cardList &&
      kanbanDataOriginal[9]?.cardList

    if (hasData) {
      const totalTodayPayments = getTotalValueFromColumn(kanbanDataOriginal[6])
      const totalLatePayments = getTotalValueFromColumn(kanbanDataOriginal[7])
      const totalRejectedPayments = getTotalValueFromColumn(
        kanbanDataOriginal[8]
      )

      setPayToday(
        totalTodayPayments + totalRejectedPayments + totalLatePayments
      )
    }
  }, [kanbanDataOriginal]) // Calcula o quanto o pagamento tem que ser feito com base nas colunas de rejeitados, atrasados e pagamento hoje

  useEffect(() => {
    const hasData =
      Array.isArray(kanbanDataOriginal) &&
      kanbanDataOriginal.length > 2 &&
      kanbanDataOriginal[0]?.cardList &&
      kanbanDataOriginal[1]?.cardList

    if (hasData) {
      const conciliationColumn = getContractFromColumn(kanbanData[0])
      const approvedColumn = getContractFromColumn(kanbanData[1])

      const contracts = [
        ...(conciliationColumn || []),
        ...(approvedColumn || []),
      ]

      setContractOptions(contracts)
    }
  }, [kanbanData]) // Alimenta as options de contrato e limpa o contrato selecionado de acordo com os dados do kambam

  useSocket((socket) => {
    // console.log(socket)
    if (socket) {
      socket.on('financial_refresh_kanban', async () => {
        await fetchEnterpriseKanban(selectedEnterprise)
      })
    }
  })

  const handleSelectEnter = async (e: any) => {
    setSelectedEnterprise(e)
  }

  useEffect(() => {
    const fetchEnterprises = async () => {
      try {
        const res = await api.fetch('get', null, `/gestor/enterprise`)
        const list = res?.data?.data || []

        setSelectedEnterprise({
          label: list[0].name || '',
          value: list[0].id || '',
        })
        const options = list.map((ent: any) => ({
          ...ent,
          label: ent.name,
          value: ent.id,
        }))

        const neoinOption = { label: 'Conta Atto', value: 'main_account' }
        setEnterprisesOptions([neoinOption, ...options])
      } catch (error) {
        console.error('Erro ao buscar empreendimentos:', error)
      }
    }
    fetchEnterprises()
  }, [])

  useEffect(() => {
    if (selectedEnterprise) {
      if (selectedEnterprise.value === 'main_account') {
        return setToggle('saques')
      }
      if (toggle === 'extrato') return
      setToggle('pagamentos')
    }
  }, [selectedEnterprise]) // Altera o valor do toggle de acordo com emprendimento selecionado

  useEffect(() => {
    if (toggle === 'pagamentos') {
      if (selectedEnterprise?.value === 'main_account') {
        setSelectedEnterprise(enterprisesOptions[1])
      }
    }
  }, [toggle]) // Altera o valor do emprendimento selecionado para segunda option se o toggle for alterado para pagamentos

  useEffect(() => {
    if (selectedEnterprise && toggle === 'extrato') {
      setLoadingKanban(true)

      const isMainAccount = selectedEnterprise.value === 'main_account'
      const url = isMainAccount
        ? `/gestor/client/${CONNECTION.ORIGIN}/extract`
        : `/gestor/enterprise/${selectedEnterprise.value}/extract`

      apiT
        .fetch('get', null, url)
        .then((res) => {
          const { data } = res.data

          const sortedData = [...data].sort(
            (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
          )

          setExtractData(sortedData)
          console.log('Extract Data RES', res)
        })
        .catch((err) => {
          console.error('Erro na requisição de extrato:', err)
        })
        .finally(() => {
          setLoadingKanban(false)
        })
    }
  }, [selectedEnterprise, toggle])

  useEffect(() => {
    if (selectedEnterprise?.value) {
      const fetchDataEnterprise = async () => {
        setLoadingKanban(true)
        setData({
          account: selectedEnterprise,
        })
        try {
          await fetchEnterpriseKanban(selectedEnterprise)
        } catch (error) {
          console.error('Error:', error)
        } finally {
          setLoadingKanban(false)
        }
      }
      fetchDataEnterprise()
    }
  }, [selectedEnterprise]) // Atualiza os dados todas as vezes que o enterprise é alterado

  useEffect(() => {
    if (!showModal && selectedEnterprise?.value === 'main_account') {
      fetchData()
    }
    if (!showModal && selectedEnterprise?.value !== 'main_account') {
      handleSelectEnter(selectedEnterprise)
    }
  }, [showModal])

  let isProcessing = false
  const onMoveCard = async (card: IObject, status: string) => {
    if (isProcessing) return
    isProcessing = true
    status = String(status)
    if (!selectedEnterprise || !selectedEnterprise.value) return
    switch (selectedEnterprise.value) {
      case 'atto': {
        break
      }
      default: {
        setReqLoading(true)

        api
          .fetch('put', { status }, `/gestor/kanban/payments/${card.id}`)
          .then(async () => {
            await fetchEnterpriseKanban(selectedEnterprise)
            setReqLoading(false)
          })
          .catch((err) => {
            console.error(err)
            return setReqLoading(false)
          })
          .finally(() => {
            setReqLoading(false)
            isProcessing = false
          })
      }
    }
  } // Função q conecta o back ao kambam

  const formatName = (str: string) => {
    return str
      .toLowerCase() // Converte para minúsculas
      .normalize('NFD') // Normaliza a string para a forma de decomposição canônica NFD
      .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
      .replace(/[^a-z0-9\s]/g, '') // Remove caracteres não alfanuméricos, exceto espaços
      .trim() // Remove espaços no início e no fim
  }

  useEffect(() => {
    // *************************************************************
    // FILTRAR DADOS DO KANBAN
    // *************************************************************
    const filters: ((card: any) => boolean)[] = [] // Lista de funções de filtro

    function isNumber(value: string): boolean {
      // Remove espaços e caracteres especiais como parênteses, hífens, etc.
      value = value.trim().replace(/[.,()-\s]/g, '')

      // Verifica se o valor restante é puramente numérico
      const validPattern = /^[0-9]+$/
      return validPattern.test(value)
    }

    const applyFilters = (dataFilter: any[]) => {
      return dataFilter.map((column: any) => ({
        ...column,
        cardList: column.cardList.filter((card: any) =>
          filters.every((filter) => filter(card))
        ),
      }))
    } // Aplica todos os filtros

    if (documentCliente) {
      filters.push((card: any) => {
        const filterLetters = formatName(card?.name).includes(
          formatName(documentCliente)
        )

        const filterNumbers =
          String(clearString(card?.document)).includes(
            clearString(documentCliente)
          ) ||
          String(clearString(card?.cellphone)).includes(
            clearString(documentCliente)
          )
        return isNumber(documentCliente) ? filterNumbers : filterLetters
        // Se for número, filtra por número, senão filtra por nome
      })
    }

    if (especialistaFiltro?.length) {
      const specialistIds = especialistaFiltro.map(
        (item: { value: any }) => item.value
      )
      filters.push((card: any) => specialistIds.includes(card.specialistId))
    } // Adiciona filtro de especialistas se houver

    if (selectedGestor?.value) {
      filters.push(
        (card: any) =>
          card?.superior?.id === selectedGestor.value ||
          card?.specialistId === selectedGestor.value
      ) // Adiciona filtro de gestor
    }

    if (selectedContract?.length) {
      const selectedValues = selectedContract.map(
        (contract: { value: string }) => contract.value
      )
      filters.push((card: any) => {
        const contractValue = card.tags?.[0]?.value
        return selectedValues.includes(contractValue)
      })
    }

    if (dateRange?.startDate || dateRange?.endDate) {
      filters.push((card: any) => {
        const date = card.filterData ? new Date(card.filterData) : null

        const start = dateRange?.startDate
          ? new Date(dateRange.startDate)
          : null
        const end = dateRange?.endDate ? new Date(dateRange.endDate) : null

        const isSameDay = (d1: Date, d2: Date) =>
          d1.getFullYear() === d2.getFullYear() &&
          d1.getMonth() === d2.getMonth() &&
          d1.getDate() === d2.getDate()

        const isInRange = (dateF: Date | null) => {
          if (!dateF) return false

          if (start && end) {
            const time = dateF.getTime()
            return time >= start.getTime() && time <= end.getTime()
          }

          if (start) return isSameDay(dateF, start)
          if (end) return isSameDay(dateF, end)

          return false
        }

        return isInRange(date)
      })
    }
    const filteredData = applyFilters(kanbanDataOriginal)

    setKanbanData(filteredData)
  }, [
    documentCliente,
    especialistaFiltro,
    kanbanDataOriginal,
    selectedGestor,
    selectedContract,
    dateRange,
  ])

  useEffect(() => {
    setSelectedContract(null)
  }, [documentCliente, especialistaFiltro, kanbanDataOriginal, selectedGestor]) //  limpa o contrato selecionado se algum outro filtro é selecionado

  useEffect(() => {
    if (selectedGestor?.value) {
      const filtered = filteredEspecialistOptionsInitial.filter(
        (especialist: { superior: { id: any }; id: any }) =>
          especialist.superior?.id === selectedGestor.value ||
          especialist.id === selectedGestor.value
      )
      setEspecialistaFiltro([])

      setFilteredEspecialistOptions(filtered)
    } else {
      setFilteredEspecialistOptions(filteredEspecialistOptionsInitial)
    }
  }, [selectedGestor])
  // Filtra os especialistas de acordo com o gestor selecionado

  const isDeletable = toggle !== 'saques'

  const handleDelete = (id: string) => {
    console.log(typeof id)
    selectedId.current = id
    console.log(id)
    setLocalModal(true)
  }

  return (
    <Container isExpanded={searchMenuIsExpanded}>
      <PageScrollContent flexDirection="row">
        <SearchMenu
          setIsExpanded={setSearchMenuIsExpanded}
          isExpanded={searchMenuIsExpanded}
        >
          <div className="financial-left-container">
            <Filter2
              key={JSON.stringify(enterprisesOptions)}
              options={enterprisesOptions}
              placeholder="Empreendimento"
              selected={selectedEnterprise}
              dataTestId="filter-enterprise"
              onChange={(e: any) => handleSelectEnter(e)}
            />

            <SearchBarComponent
              disabled={toggle === 'extrato'}
              dataTestId="search-name-tel-document"
              placeholder={'CPF/CNPJ, Nome ou Tel.'}
              onChange={(e: any) => {
                setDocumentoCliente(e.target.value)
              }}
            />
            <FilterMulti
              disabled={toggle === 'extrato'}
              icon={Icon('doc.svg')}
              placeholder="Contrato"
              dataTestId="filter-specialist"
              options={contractOptions}
              setSelected={setSelectedContract}
              selected={selectedContract}
            />
            {toggle !== 'extrato' && (
              <SearchDates
                dateRange={dateRange}
                setDateRange={setDateRange}
                setShowDataPicker={setShowDataPicker}
                showDataPicker={showDataPicker}
              />
            )}
            <Filter2
              disabled={toggle === 'extrato'}
              icon={Icon('filter.svg')}
              placeholder="Gestores"
              dataTestId="filter-specialist"
              isClearable
              options={[
                ...[...gestors, ...gestSpecialist].map((item: any) => ({
                  label: item.name,
                  value: item.id,
                  profilePic: item.profilePic,
                })),
              ]}
              setSelected={setSelectedGestor}
              selected={selectedGestor}
            />
            <FilterMulti
              disabled={toggle === 'extrato'}
              key={JSON.stringify(filteredEspecialistOptions)}
              icon={Icon('trophy.svg')}
              placeholder="Especialista"
              dataTestId="filter-specialist"
              options={[
                ...filteredEspecialistOptions.map((item: any) => ({
                  label: item.name,
                  value: item.id,
                  profilePic: item.profilePic,
                })),
              ]}
              setSelected={setEspecialistaFiltro}
              selected={especialistaFiltro}
            />

            {especialistaFiltro && especialistaFiltro.length > 0 && (
              <SelectedSpecialists
                especialistaFiltro={especialistaFiltro}
                setEspecialistaFiltro={setEspecialistaFiltro}
              />
            )}
          </div>
        </SearchMenu>

        <div className="financial-right-container">
          <HeaderPage path="Financeiro" />

          <Toggle toggle={toggle} setToggle={setToggle} options={optGeneral} />

          {kanbanData &&
            kanbanData.length > 0 &&
            !loadingKanban &&
            toggle !== 'extrato' && (
              <>
                <div className="financial-cards-container">
                  <FinancialCard dataTestId="enterprise-balance-card">
                    {
                      <>
                        <div className="upperTxt">
                          Saldo em conta{' '}
                          <span className="boldTxt ">
                            {selectedEnterprise?.label}
                          </span>
                        </div>
                        <div className="green lowerTxt ">
                          {cardData.balance}
                        </div>
                      </>
                    }
                  </FinancialCard>
                  <Line />
                  <FinancialCard
                    dataTestId={
                      selectedEnterprise?.value === 'main_account'
                        ? `user-balance-card`
                        : `payment-card`
                    }
                  >
                    {
                      <>
                        <div className="upperTxt">
                          {selectedEnterprise?.value === 'main_account'
                            ? `Saldo em conta dos clientes`
                            : `Pagar hoje`}
                        </div>
                        <div className="lowerTxt ">
                          {selectedEnterprise?.value === 'main_account'
                            ? `R$ ${(cardData.usersBalance ?? 0).toLocaleString(
                                'pt-BR',
                                {
                                  minimumFractionDigits: 2,
                                }
                              )}`
                            : `R$ ${payToday.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                              })}`}
                        </div>
                      </>
                    }
                  </FinancialCard>
                  <Line />
                  <DefaultButton
                    onClick={openDepositar}
                    icon={Icon('plus.svg')}
                    xsmall
                    disabled
                    // disabled={!hasAccess('depositar-financial')}
                  >
                    Depositar
                  </DefaultButton>
                  <DefaultButton
                    onClick={openTransferir}
                    icon={Icon('repeat.svg')}
                    xsmall
                    disabled
                    // disabled={!hasAccess('transfer-financial')}
                  >
                    Transferir
                  </DefaultButton>
                </div>

                <KanbanEnviromnent reqLoading={reqLoading}>
                  <div className="container-kanban">
                    {reqLoading && (
                      <img
                        className="grey-loagind"
                        src={logoSmall}
                        alt="card icon"
                      />
                    )}
                    <Kanban2
                      showDataPicker={showDataPicker}
                      columnsWithTrash={isDeletable ? [10, 11] : []}
                      onTrash={handleDelete}
                      handleClick={toggle !== 'saque' ? openDetails : undefined}
                      noSpecialist={
                        selectedEnterprise?.value === 'main_account'
                      }
                      data={kanbanData}
                      investCard={false}
                      key={JSON.stringify(kanbanData)}
                      setData={setKanbanData}
                      onDropCard={onMoveCard}
                    />
                  </div>
                </KanbanEnviromnent>
              </>
            )}
          {toggle === 'extrato' && !loadingKanban && (
            <Extrato
              initalData={extractData}
              dateRange={dateRange}
              setDateRange={setDateRange}
            />
          )}
          {loadingKanban && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                alignSelf: 'center',
                width: '100%',
              }}
            >
              <Loading modal />
            </div>
          )}
        </div>
      </PageScrollContent>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        {modalData}
      </Modal>
      <NewModal
        showModal={localModal}
        height="45%"
        width="60%"
        setShowModal={setLocalModal}
        noCloseButton
        padding={'30px'}
      >
        {[
          [
            <DeleteProposta
              onCancel={() => setLocalModal(false)}
              id={selectedId.current}
            />,
            'Excluir proposta',
          ],
        ]}
      </NewModal>
      <NewModal
        backButton
        showModal={transcModal}
        height="75%"
        width="75%"
        setShowModal={setTransacModal}
        padding={'30px'}
      >
        {transcModal}
      </NewModal>
    </Container>
  )
}
